// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

const c_gold = 10000000000;
@ccclass
export default class SuperPowerSelect3 extends BasePopUpLayer {
    @property(cc.Node)
    nodeGold: cc.Node = null;
   
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getServices().userSrv.setCoins(c_gold, true, this.nodeGold);
        this.destroyNode();
        this._carryData.parent.showEndUI('我们下次再见');
    }

    // update (dt) {}
}
